{
  "schemaVersion": 1,
  "id": "sheesham-board-38",
  "version": "1.0",
  "kind": "board",
  "species": "Sheesham",
  "material": "Solid sheesham",
  "nominalDescription": "Solid sheesham 38 mm, planed all round, oiled",
  "edgeDescription": "Solid sheesham, planed, 1 mm arris",
  "thicknessTicks": 380,
  "nominalThicknessTicks": 380,
  "maxWidthTicks": 2000,
  "maxLengthTicks": 24000,
  "grainAxis": "length",
  "finishSpec": "Hard-wax oil, two coats",
  "density": 770,
  "back": {
    "description": "Birch plywood 6 mm, B/BB, stained to match",
    "thicknessTicks": 60,
    "nominalThicknessTicks": 60,
    "sheet": {
      "lengthTicks": 24400,
      "widthTicks": 12200
    },
    "grainAxis": "length",
    "allowRotation": false
  },
  "notes": "Self-authored thick board stock for chunky solid frames (FND-23): sheesham planed to 38 mm, sold in the same widths as the sheesham-board-25 profile (up to 200 mm); wider parts are edge-glued from strips by the same rule (plan \u00a75). Back and finish as sheesham-board-25."
}
